import { AppointmentWindowListDTO, BlockTypeEnum, TimezoneAbbreviationEnum } from '../api/apiTypes.shim';
import { DateFormatEnum, DateUtils } from '../utils/date.utils';

/**
 * @returns +/- minute difference from CutOffTime - Now
 */
export const minutesBeforeCutOff = (
  appointmentWindow: Pick<AppointmentWindowListDTO, 'cutOffTimeMinutes'>,
  bookingDate: Date,
  timezone: TimezoneAbbreviationEnum
) => {
  const now = new Date();
  const cutOffTime = DateUtils.fromDateAndMinutesToDate(bookingDate, appointmentWindow.cutOffTimeMinutes, timezone);
  return DateUtils.getDifferenceInMinutes(cutOffTime, now, timezone);
};

export const getBlockTypeAndTimeDisplay = (
  appointmentWindow: Pick<AppointmentWindowListDTO, 'startTime' | 'endTime' | 'blockType'>,
  timezone: TimezoneAbbreviationEnum
) => {
  const startTimePretty = DateUtils.format(appointmentWindow.startTime, DateFormatEnum.Time, {
    timezone
  });

  if (appointmentWindow.blockType === BlockTypeEnum.SPECIFIC_TIME) {
    return `@ ${startTimePretty}`;
  }

  if (appointmentWindow.blockType === BlockTypeEnum.RANGE) {
    const endTimePretty = DateUtils.format(appointmentWindow.endTime, DateFormatEnum.Time, {
      timezone
    });
    return `@ ${startTimePretty}-${endTimePretty}`;
  }

  return '(ALL DAY)';
};
